import React, { useEffect, useState, useContext } from "react";
import { Dropdown } from "react-bootstrap";
import { AuthContext, cleverLogoutUrl, cleverPortalUrl, webflowUrl } from "@app/providers";
import { useLocation } from "@app/utils";
import { logoutUser } from "@app/services";
import { getDefaultUrl } from "@app/routes/route-helpers";
import { Icon, Toast } from "@app/components";
import { KazooLogo } from "@app/assets";
import {
  HeaderRow,
  ProfileImage,
  UserMenu,
  Title,
  Username,
  CustomToggleWrapper,
  MenuItemsWrapper,
  MenuItem,
  RightContainer,
  HamburgerMenu,
} from "./header.component";
import LogOutDialog from "./logout-dialog";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faCaretDown } from "@fortawesome/free-solid-svg-icons";

export default function Header() {
  const { userInfo, setUserInfo }: any = useContext(AuthContext);
  const { navigate } = useLocation();
  const [userDetails, updateUserDetails] = useState<any>({});
  const [showLogOut, setShowLogOut] = useState<boolean>(false);
  const [logOutText, setLogOutText] = useState<string>("Logout");
  const [showToast, setShowToast] = React.useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 576);
  const [menuClicked, setMenuClicked] = useState<boolean>(false);
  const [toastMessage, setToastMessage] = useState<any>({
    type: "",
    message: "",
  });

  useEffect(() => {
    if (userInfo && userInfo.sessionToken) {
      const user = userInfo.userJson;
      updateUserDetails(user);
    }
  }, [userInfo]);
  
  const CustomToggle = React.forwardRef<any, any>(({ onClick }, ref) => (
    <div
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      <CustomToggleWrapper>
        {userDetails && userDetails.thumbnailAsset && (
          <ProfileImage>
            <img
              src={userDetails.thumbnailAsset}
              alt="Profile"
              className="image cover"
            />
          </ProfileImage>
        )}
        {userDetails && !userDetails.thumbnailAsset && (
          <ProfileImage>
            <div className="image contained">
              <Icon name="profile" />
            </div>
          </ProfileImage>
        )}
        <FontAwesomeIcon icon={faCaretDown} color="#FFF" />
      </CustomToggleWrapper>
    </div>
  ));

  function toggleMenu() {
    setMenuClicked(!menuClicked)
  }

  useEffect(() => {
    window.addEventListener("resize", () => {
      const ismobile = window.innerWidth < 1200;
      if (ismobile !== isMobile) setIsMobile(ismobile);
    }, false);
  }, [isMobile]);

  function logout() {
    const params: any = {};
    Object.assign(params, {
      userId: userDetails.userId,
      sessionToken: userInfo.sessionToken,
    });
    setLogOutText("Logging Out...");
    logoutUser(params)
      .then((res: any) => {
        setLogOutText("Logout");
        // let userJson = localStorage.getItem("userData");
        // const userData = JSON.parse(userJson || '{}')
        // if(userData.userJson.cleverAccountId){
        //   window.open(cleverPortalUrl)
        //   setTimeout(() => { window.open(cleverLogoutUrl); }, 1500);
        //   window.close();
        // }
        if (res._responseStatus === 1) {
          localStorage.clear();
          setUserInfo(null);
          navigate("/sign-in");
        } else if (res.msgCode === "SSN_002") {
          localStorage.clear();
          setUserInfo(null);
          navigate("/sign-in");
        }
      })
      .catch((err: any) => {
        setLogOutText("Logout");
        setShowToast(true);
        setToastMessage({
          type: "error",
          message: `Something went wrong, Please try again`,
        });
      });
  }
  
  const defaultUrl: string = getDefaultUrl(userDetails);
  
    
  function getLink(link: string) {
    if (/^(f|ht)tps?:\/\//i.test(link)) {
      return link;
    } else return 'http://' + link;
  }
  function logoRedirection() {
    window.open(webflowUrl, "_self")
  }
  return (
    <>
      <HeaderRow>
        {isMobile &&
          <HamburgerMenu onClick={() => toggleMenu()}>
            <FontAwesomeIcon icon={faBars} style={{ width: '20px', height: '20px', color: '#00BE9A' }}></FontAwesomeIcon>
          </HamburgerMenu>
        }
        <span style={{ cursor: "pointer" }} onClick={() => logoRedirection()}>
          <img alt="KazooBadoo" src={KazooLogo}></img>
        </span>
        <RightContainer>
          {userDetails && (
            <>
              {userInfo.userJson.userType === "educator" && userInfo.userJson.educatorLicenseType === "teacherAccount" &&
                userInfo.userJson['ageVerfiedflag'] && userInfo.userJson["educatorApprovedFlag"] ?
                <MenuItemsWrapper className={isMobile ? (!menuClicked ? 'hide' : 'responsive show') : ''}>
                  <MenuItem className={isMobile ? 'responsive' : ''} onClick={() => { navigate('/classrooms'); setMenuClicked(false) }}>
                    <h4>My Classrooms</h4>
                  </MenuItem>   </MenuItemsWrapper> : ""}

              {userInfo.userJson.userType === "educator" && userInfo.userJson.educatorLicenseType === "schoolLicenseCode" ?
                <MenuItemsWrapper className={isMobile ? (!menuClicked ? 'hide' : 'responsive show') : ''}>
                  <MenuItem className={isMobile ? 'responsive' : ''} onClick={() => { navigate('/classrooms'); setMenuClicked(false) }}>
                    <h4>My Classrooms </h4>
                  </MenuItem>   </MenuItemsWrapper> : ""}
              {userInfo.userJson.userType === "student" ?
                <MenuItemsWrapper className={isMobile ? (!menuClicked ? 'hide' : 'responsive show') : ''} >
                  <MenuItem className={isMobile ? 'responsive' : ''} onClick={() => { navigate('/classrooms'); setMenuClicked(false) }} >
                    <h4>My Classrooms </h4>
                  </MenuItem>   </MenuItemsWrapper> : ''}
              <UserMenu>
                <Username className="text-ellipsis">
                  {userDetails.firstName} {userDetails.lastName}
                </Username>
                <Dropdown>
                  <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">Custom toggle</Dropdown.Toggle>
                  <Dropdown.Menu
                    style={{
                      width: "225px",
                      borderRadius: "8px",
                      padding: "15px 0px",
                      background: "#FFF",
                    }}
                  >
                    <Dropdown.Item
                      style={{ color: " #555555", fontWeight: 600 }}
                      eventKey="1"
                      onClick={() => navigate("/profile")}
                      disabled={userInfo.userJson.userType === 'student' &&
                        userInfo.userJson.passwordResetNotDone && userInfo.userJson.passwordResetNotDone === true}
                    >
                      My Account
                    </Dropdown.Item>


                    {(userInfo.userJson.userType === 'parent' ||
                      (userInfo.userJson.userType === "educator" && userInfo.userJson['ageVerfiedflag'] && userInfo.userJson["educatorApprovedFlag"])) &&
                      <Dropdown.Item
                        style={{ color: " #555555", fontWeight: 600 }}
                        eventKey="1"
                        onClick={() => navigate("/create-avatar")}
                      // disabled={userInfo.userJson.userType === 'student' &&
                      //   userInfo.userJson.passwordResetNotDone && userInfo.userJson.passwordResetNotDone === true}
                      >
                        Play Game
                    </Dropdown.Item>}

                    <Dropdown.Item
                      eventKey="2"
                      style={{ color: " #555555", fontWeight: 600 }}
                      onClick={() => navigate("/change-password")}
                    >
                      Change Password
                    </Dropdown.Item>

                    <Dropdown.Item
                      style={{ color: " #555555", fontWeight: 600 }}
                      eventKey="3"
                      onClick={() => setShowLogOut(true)}
                    >
                      Logout
              </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </UserMenu>
            </>
          )}
        </RightContainer>
      </HeaderRow>
      {showLogOut && (
        <LogOutDialog
          onClose={() => setShowLogOut(false)}
          logoutUser={() => logout()}
          logoutText={logOutText}
        />
      )}
      <Toast
        message={toastMessage.message}
        showToast={showToast}
        type={toastMessage.type}
        onClose={() => setShowToast(false)}
      />
    </>
  );
}
